import {Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[appActiveTabsQ]'
})
export class ActiveTabsDirectiveQ {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    let $toggle = false;
    let q: any[] = JSON.parse(localStorage.getItem('openedSubcategoriesQ'));
    if (!q) {
      q = [];
      localStorage.setItem('openedSubcategoriesQ', JSON.stringify(q));
    } else {
      setTimeout(() => {
        console.log(q);
        for (let z = 0; z < q.length; z ++) {
          if (q[z] === el.nativeElement.value) {
            $toggle = true;
            renderer.addClass(el.nativeElement, 'open');
          }
        }
      }, );
    }
  }
  
  @HostListener('click') clickEvent() {
    let bla = true;
    let r: any[] = JSON.parse(localStorage.getItem('openedSubcategoriesQ'));
    
    if (!r) {
      r = [];
      localStorage.setItem('openedSubcategoriesQ', JSON.stringify(r));
    }
    
    if (r.length > 0) {
      let w = JSON.parse(localStorage.getItem('openedSubcategoriesQ'));
      for (let y = 0; y < w.length; y++) {
        if (w[y] === this.el.nativeElement.value) {
          let index = w.indexOf(w[y]);
          if (index !== -1) {
            w.splice(index, 1);
          }
          bla = null;
          this.renderer.removeClass(this.el.nativeElement, 'open');
          break;
        }
      }
      if (bla) {
        w.push(this.el.nativeElement.value);
        this.renderer.addClass(this.el.nativeElement, 'open');
      }
      localStorage.setItem('openedSubcategoriesQ', JSON.stringify(w));
    } else {
      r.push(this.el.nativeElement.value);
      localStorage.setItem('openedSubcategoriesQ', JSON.stringify(r));
      this.renderer.addClass(this.el.nativeElement, 'open');
    }
  }
}
